






import { Component, Prop, Vue } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IInvoice } from "@/models/invoices";
import { Location as VueLocation } from "vue-router";

@Component
export default class PayInvoiceCta extends Vue {
  // Props
  @Prop({ required: true })
  public invoice!: IInvoice;

  @Prop({ default: null })
  public externalAuthReturnLocation!: VueLocation;

  // Getters
  public get isVisible() {
    return (
      // Invoice is unpaid
      this.$store.getters[`data/${DataModules.INVOICES}/isDue`](this.invoice) &&
      // Balance is greater than 0
      this.$_.get(this.invoice, "unpaid_amount_converted", 0)
    );
  }
  // Methods
  public async openPayInvoiceModal() {
    const modal = await this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/payments/invoicePaymentModal.vue"),
        props: {
          invoice: this.invoice,
          externalAuthLocationFunc: this.externalAuthReturnLocation
            ? () => {
                return this.externalAuthReturnLocation;
              }
            : null
        },
        width: 740,
        events: {
          "payment-method-changed": payload => {
            this.$emit("payment-method-changed", payload);
          },
          success: () => {
            modal.close();
            this.$emit("paid");
          }
        }
      }
    });
  }
}
